// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
import htmlToPdf from './assets/htmlToPdf'
// import mopdf from './assets/mopdf'
import MetaInfo from 'vue-meta-info';
import htmlToPdfs from './assets/pdf'




Vue.use(htmlToPdfs)
Vue.use(MetaInfo);
Vue.use(htmlToPdf)
// Vue.use(mopdf)
Vue.prototype.$axios = axios
Vue.use(ElementUI);
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js